import React from 'react';

import {Owner} from 'auth/PermissionConstants';
import navigateToURL from 'lib/navigateToURL';
import {ClientSchemaField} from 'registry/field/FieldTable';
import {sanitizeFields} from 'registry/RegistryUtil';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {BenchlingAppSummary} from 'schemas/SchemaConstants';
import {getSchemaOwnerChoices} from 'schemas/spec/SchemaSpecUtil';
import nameToSqlIdentifier from 'warehouse/nameToSqlIdentifier';

export function getOwnerById(ownerId: string | null): Owner | null {
  if (ownerId == null) {
    return null;
  }
  return getSchemaOwnerChoices().find((owner) => owner.id === ownerId) || null;
}

export function massageFieldsForSubmit(fields: Array<ClientSchemaField | SchemaField>): Array<SchemaField> {
  // Don't submit info on relatedBenchlingApps or appliedFieldset, if any
  // Keep the return value in sync with /src/benchling/schemas/specs/json_spec_adapter.py:255
  return sanitizeFields(fields).map(({relatedBenchlingApps, appliedFieldset, ...field}) => ({
    ...field,
    // Use || instead of ?? to handle the systemName='' case
    systemName: field.systemName || nameToSqlIdentifier(field.displayName),
  }));
}

export function getMessageForRelatedApps(relatedBenchlingApps: Array<BenchlingAppSummary>): JSX.Element {
  const numBenchlingApps = relatedBenchlingApps.length;
  const appUrls = relatedBenchlingApps.slice(0, 3).map((appSummary, i) => (
    <span key={i}>
      {i > 0 && ', '}
      <a
        onClick={() => {
          navigateToURL(appSummary.url);
        }}
      >
        {appSummary.name}
      </a>
    </span>
  ));
  let relatedBenchlingAppsMsg;
  if (numBenchlingApps > 3) {
    relatedBenchlingAppsMsg = (
      <>
        {appUrls} + {numBenchlingApps - 3} more
      </>
    );
  } else {
    relatedBenchlingAppsMsg = <>{appUrls}</>;
  }
  return <span>Referenced by app config(s) for: {relatedBenchlingAppsMsg}</span>;
}
